export default function LogoOnly() {
  return (
    <svg
      width="52"
      height="30"
      viewBox="0 0 52 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5213 23.0811C5.968 20.5042 4.4082 14.7961 7.03736 10.3326C9.66559 5.86909 15.4872 4.33972 20.0396 6.91667L22.4186 2.87602C20.0819 1.55219 17.7136 1 15.0332 1C10.1905 1.08689 5.51307 3.58748 2.91537 7.99983C-1.02752 14.6947 1.31227 23.2567 8.14129 27.1227C14.9703 30.9876 23.7027 28.6936 27.6445 21.9987C29.9349 18.1097 32.2244 14.2216 34.5139 10.3326L40.0096 19.6652H32.4844L29.737 24.3315H42.7569L45.5053 28.9978H51L34.5139 1L27.6436 12.6672H16.6532L13.9058 17.3335H24.8962L23.5235 19.6652C20.8952 24.1296 15.0736 25.6581 10.5213 23.0811Z"
        fill="url(#paint0_linear_97_1141)"
        stroke="#231F20"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id="paint0_linear_97_1141"
          x1="4.48171"
          y1="24.5802"
          x2="40.4121"
          y2="11.5223"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24" />
          <stop offset="0.26" stopColor="#EC281E" />
          <stop offset="0.73" stopColor="#EC480E" />
          <stop offset="1" stopColor="#EC5E04" />
        </linearGradient>
      </defs>
    </svg>
  );
}
